import React, { useEffect, useState } from "react"
import { IReplenishmentDto } from "../../../../../types/replenishment/IReplenishmentDto"
import { IFullCompanyDto } from "../../../../../types/company/IFullCompanyDto"
import * as TrinityAPI from "../../../../../requests/TrinityAPI"
import { IModalMessage } from "../../../../../types/error/IModalMessage"
import { ModalPopUp } from "../../../../common/element/ModalPopUp"
import { IMG } from "../../../../common/CONST"
import { download, getFormattedDate, round2Digits, round4Digits, spacedNum } from "../../../../common/CommonHelper"
import { IProfileDto } from "../../../../../types/user/IProfileDto"

import style from "./style.module.scss"
import Button from "@/ui/components/Button"

interface ITemplateResponse {
  contractId: string
  agreementId: string
}

export const CRTab: React.FC<{
  replenishment: IReplenishmentDto
  setReplenishment: (r: IReplenishmentDto) => void
  crAcceptance: (accepted: boolean) => void
  showFixed?: boolean
}> = ({ replenishment, setReplenishment, crAcceptance, showFixed }) => {
  const [company, setCompany] = useState<IFullCompanyDto>()
  const [modalMessage, setModalMessage] = useState<IModalMessage | null>(null)
  const [sending, setSending] = useState(false)
  const [profile, setProfile] = useState<IProfileDto>()

  useEffect(() => {
    if (!replenishment.companyId) return
    TrinityAPI.getProfile(response => {
      if (response.status === 200) setProfile(response.data)
    })
    TrinityAPI.getCompany(replenishment.companyId, response => {
      if (response.status === 200) {
        setCompany(response.data)
      } else {
        setModalMessage({
          title: "Ошибка!",
          text: `Ошибка получения компании: ${response.data.message}`
        })
      }
    })
  }, [])

  // useEffect(() => {
  //   if (replenishment.clientRequestId && replenishment.status !== "NEW") {
  //     TrinityAPI.getClientRequest(Number(replenishment.clientRequestId), response => {
  //       if (response.status === 200) {
  //         setPayerCompanyName(response.data.clientCompanyName)
  //       }
  //     })
  //   }
  // }, [replenishment])

  const isEditable = () => {
    return replenishment.status === "DOC_ACC" || replenishment.status === "CR_NAC"
  }

  const submitCRRequest = (client: boolean, auto: boolean) => {
    if (sending) return
    const r: IReplenishmentDto = {
      clientRate: undefined,
      id: replenishment.id,
      companyId: replenishment.companyId
    }
    if (client) {
      if (!replenishment.clientRate) {
        setModalMessage({ title: "Ошибка!", text: `Заполните ставку, или выберите предложенную` })
        return
      }
      if (Number(replenishment.clientRate) > 5.5) {
        setModalMessage({ title: "Ошибка!", text: `Ставка не может быть выше 5.5%` })
        return
      }
      if (Number(replenishment.clientRate) < Number(company?.baseRate)) {
        setModalMessage({ title: "Ошибка!", text: `Ставка не может быть ниже предложенной ставки` })
        return
      }
      r.clientRate = replenishment.clientRate
    }
    setSending(true)
    TrinityAPI.requestCR(
      r,
      auto,
      response => {
        if (response.status === 200) {
          window.location.reload()
        } else {
          setModalMessage({
            title: "Ошибка!",
            text: `Ошибка отправки запроса: ${response.data.message}`
          })
        }
      },
      () => setSending(false)
    )
  }

  const changeClientRate = (val: string) => {
    if (!val || val.length === 0) {
      setReplenishment({ ...replenishment, clientRate: undefined })
      return
    }
    setReplenishment({
      ...replenishment,
      clientRate: val.replace(/,/g, ".").replace(/[^0-9.]/g, "").replace(/(\..*?)\..*/g, "$1")
    })
  }

  // const calculatePercentRUB = () => {
  //   const invoicePriceUSD = Number(replenishment.usdAmountBefore) / 100
  //   const clearRUB = round2Digits(invoicePriceUSD * Number(replenishment.rateBefore))
  //   return round2Digits(Number(replenishment.rubAmountBefore) / 100 - clearRUB)
  // }

  // const calculateInvoiceAmount = () => {
  //   const rateX2 = (Number(replenishment.rateAfter) / 100) * getCalculationRateAfter() + Number(replenishment.rateAfter) // with rate
  //   const xRateX2 = rateX2 / Number(replenishment.xRateAfter)
  //   return round2Digits(Number(replenishment.rubAmountAfter) / xRateX2 / 100)
  // }

  const getPercentRate = () => {
    let calculationRate = Number(replenishment.offeredRate)
    if (replenishment.clientRate) {
      calculationRate = Number(replenishment.clientRate)
    } else {
      if (Number(replenishment.amountRate) > 0) {
        calculationRate = Number(replenishment.amountRate)
      }
      if (Number(replenishment.volumeRate) > 0 && Number(replenishment.volumeRate) < Number(calculationRate)) {
        calculationRate = Number(replenishment.volumeRate)
      }
    }
    return calculationRate
  }

  const getOnTopAmount = () => {
    if (replenishment.onTopAmount) {
      return ` + ${spacedNum(Number(replenishment.onTopAmount) / 100)} USD`
    }

    return ""
  }

  // const getCalculationRateBefore = (): number => {
  //   let calculationRate = Number(replenishment.offeredRate)
  //   if (replenishment.clientRate) {
  //     calculationRate = Number(replenishment.clientRate)
  //   } else {
  //     calculationRate = calculateCommonRate(calculationRate)
  //   }
  //   return calculationRate
  // }

  const getCalculationRateAfter = (): number => {
    let calculationRate = Number(replenishment.offeredRate)
    return calculateCommonRate(calculationRate)
  }

  const calculateCommonRate = (calculationRate: number): number => {
    if (replenishment.amountRate && Number(replenishment.amountRate) > 0) {
      calculationRate = Number(replenishment.amountRate)
    }
    if (
      replenishment.volumeRate &&
      Number(replenishment.volumeRate) > 0 &&
      Number(replenishment.volumeRate) < calculationRate
    ) {
      calculationRate = Number(replenishment.volumeRate)
    }
    return calculationRate
  }

  const createUpdateTemplate = () => {
    if (!replenishment.id) return
    TrinityAPI.createUpdateTemplate(replenishment.id, response => {
      if (response.status === 200) {
        const templateResponse: ITemplateResponse = response.data
        setReplenishment({
          ...replenishment,
          contractId: templateResponse.contractId,
          additionalAgreementId: templateResponse.agreementId
        })
        setModalMessage({
          title: "Успех",
          text: `Шаблон успешно создан и добавлен к вашему контрагенту`
        })
      } else {
        setModalMessage({
          title: "Ошибка!",
          text: `Ошибка создания шаблона: ${response.data.message}`
        })
      }
    })
  }

  if (replenishment.status === "DOC_ACC" || replenishment.status === "CR_NAC" || replenishment.status === "CR_REQ") {
    return (
      <>
        <ModalPopUp message={modalMessage} close={() => setModalMessage(null)} />
        <div className="container" style={!isEditable() ? { pointerEvents: "none", opacity: 0.7 } : {}}>
          <div className="container-pop-up">
            {replenishment.status === "CR_REQ" && (
              <>
                <p className="message-course-yes">
                  Ставка запрошена. После окончания формирования ставки вы сможете продолжить
                </p>
              </>
            )}
            <ul className={style.currencyRequestList}>
              <li className="form-block-popup">
                <div>
                  <h4 className="heading-chapter">Расчет по ставке платформы</h4>
                  <p className="text-block">
                    Ставка может измениться в меньшую сторону (на основании суммы или месячного оборота) после запроса
                    курса
                  </p>
                </div>
                <div className={style.requestCR}>
                  <p>Запросить по ставке</p>
                  <div className={style.buttonsWrapper}>
                    <Button onClick={() => submitCRRequest(false, false)}>Платформы</Button>
                    {profile?.autoCr && (
                      <Button variant="black" className="textCenter" onClick={() => submitCRRequest(false, true)}>
                        ЦБ
                      </Button>
                    )}
                  </div>
                </div>
              </li>
              {!replenishment.personalRateRequested && (
                <li className="form-block-popup">
                  <div>
                    <h4 className="heading-chapter">Расчет по ставке клиента</h4>
                    <input
                      type="text"
                      className="input-form"
                      placeholder="Введите ставку"
                      value={replenishment.clientRate}
                      onChange={e => changeClientRate(e.target.value)}
                    />
                    <p className="text-block">Вы можете назначить свою ставку ставку, но не более 5.5%</p>
                  </div>
                  <div className={style.requestCR}>
                    <p>Запросить по ставке</p>
                    <div className={style.buttonsWrapper}>
                      <Button onClick={() => submitCRRequest(true, false)}>Платформы</Button>
                      {profile?.autoCr && (
                        <Button variant="black" className="textCenter" onClick={() => submitCRRequest(true, true)}>
                          ЦБ
                        </Button>
                      )}
                    </div>
                  </div>
                </li>
              )}
              {replenishment.contractorId && replenishment.contractId && replenishment.additionalAgreementId ? null : (
                <li className="form-block-popup template_card">
                  <div>
                    <h4 className="heading-chapter">Создать шаблон</h4>
                    {/*<input type="text" className="input-form" placeholder="Имя шаблона"/>*/}
                    <p className="text-block">
                      Шаблон будет создан на основании контрагента, контракта, инвойса, даты инвойса и дополнительных
                      соглашений
                    </p>
                  </div>
                  <button className="btn width-fit" onClick={createUpdateTemplate}>
                    {replenishment.contractId && !replenishment.additionalAgreementId
                      ? "Обновить шаблон"
                      : "Создать шаблон"}
                  </button>
                </li>
              )}
            </ul>
          </div>
        </div>
      </>
    )
  } else if (
    replenishment.status === "CR_AWT" ||
    replenishment.status === "CR_ACC" ||
    replenishment.status === "BILL" ||
    replenishment.status === "BILL_PAID" ||
    replenishment.status === "CR_FIX" ||
    (replenishment.status === "DONE" && !showFixed)
  ) {
    return (
      <>
        <ModalPopUp message={modalMessage} close={() => setModalMessage(null)} />
        <div className="container">
          <div className="container-pop-up">
            <div className="course-apply_block width-full">
              <ul className="course-flex-block flex-wrap-mobile">
                <li className="course-status-block">
                  <p className="course-summ-usd">
                    <p className="course-summ-usd-percent">
                      <span>Сумма пополнения в валюте</span>
                    </p>
                    {spacedNum(Number(replenishment.usdAmountBefore) / 100)}
                  </p>
                </li>
                <li className="course-status-block">
                  <p className="course-summ-rub">
                    <p className="course-summ-usd-percent">
                      <span>Сумма инвойса в рублях</span>
                    </p>
                    {spacedNum(round2Digits(Number(replenishment.rubAmountBefore) / 100))}
                  </p>
                </li>
              </ul>
            </div>
            <ul className="form-full flex-wrap-mobile">
              <li className="form-block-popup justifyBetween width-4-blocks">
                <h4 className="heading-chapter">Курс USD/RUB платформы до фиксации</h4>
                <p className="valute-deal-user--small">{replenishment.rateBefore}</p>
              </li>
              <li className="form-block-popup justifyBetween width-4-blocks">
                <h4 className="heading-chapter">Ставка</h4>
                <p className="valute-deal-user--small">
                  {getPercentRate()}%{getOnTopAmount()}
                </p>
              </li>
              <li className="form-block-popup justifyBetween width-4-blocks">
                <h4 className="heading-chapter">Курс валюты инвойса до фиксации</h4>
                <p className="valute-deal-user--small">
                  {replenishment.invoiceCurrency} 1 / {replenishment.brockmanRateBefore} RUB
                </p>
              </li>
              <li className="form-block-popup justifyBetween width-4-blocks">
                <h4 className="heading-chapter">Кросс курс платформы до фиксации</h4>
                <p className="valute-deal-user--small">{replenishment.xRateBefore}</p>
              </li>
            </ul>
            {replenishment.status === "CR_AWT" ? (
              <div className="flex-row-10">
                <button className="btn" onClick={() => crAcceptance(true)}>
                  {sending ? "Подождите..." : "Подтвердить"}
                </button>
                <button className="btn grey-btn" onClick={() => crAcceptance(false)}>
                  {sending ? "Подождите..." : "Отказаться"}
                </button>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </>
    )
  } else if (replenishment.status === "DONE" && showFixed) {
    return (
      <>
        <div className="container">
          <div className="container-pop-up">
            <ul className="form-full">
              <li className="form-block-popup width-2-blocks justifyBetween">
                <h4 className="heading-chapter">Сумма пополнения в валюте</h4>
                <p className="valute-deal-user--small">{spacedNum(Number(replenishment.usdAmountAfter) / 100)}$</p>
              </li>
              <li className="form-block-popup width-2-blocks justifyBetween">
                <h4 className="heading-chapter">Сумма инвойса в рублях</h4>
                <p className="valute-deal-user--small">
                  {spacedNum(round2Digits(Number(replenishment.rubAmountAfter) / 100))} ₽
                </p>
              </li>
            </ul>

            <ul className="form-full">
              <li className="form-block-popup width-4-blocks">
                <h4 className="heading-chapter">Курс USD/RUB</h4>
                <p className="valute-deal-user">{replenishment.rateAfter}</p>
                <p className="text-block">после фиксации</p>
              </li>
              <li className="form-block-popup width-4-blocks">
                <h4 className="heading-chapter">Курс USD/{replenishment.invoiceCurrency}</h4>
                <p className="valute-deal-user">{replenishment.xRateAfter}</p>
                <p className="text-block">после фиксации</p>
              </li>
              <li className="form-block-popup width-4-blocks justifyBetween">
                <h4 className="heading-chapter">Курс валюты инвойса после фиксации</h4>
                <p className="valute-deal-user--small">
                  {replenishment.invoiceCurrency} /{" "}
                  {round4Digits(
                    Number(replenishment.rateAfter) +
                      (Number(replenishment.rateAfter) / 100) * getCalculationRateAfter()
                  )}{" "}
                  RUB
                </p>
              </li>
              <li className="form-block-popup width-4-blocks">
                <h4 className="heading-chapter">Платежные поручения</h4>
                {replenishment.paymentOrderFiles && replenishment.paymentOrderFiles?.length > 0 ? (
                  replenishment.paymentOrderFiles.map((f, index) => (
                    <fieldset className="fieldset-fit">
                      <legend></legend>
                      <button className="btn download-btn" key={index} onClick={() => download(f.id, "PAYMENT_ORDER")}>
                        <img src={IMG.download} alt="" />
                        {`Платежное поручение №${index + 1}`}
                      </button>
                    </fieldset>
                  ))
                ) : (
                  <></>
                )}
                <div className="flex-row-10">
                  <button
                    className="btn black-btn"
                    onClick={() => window.open(`/replenishment/${replenishment.id}/bill`)}
                  >
                    Открыть счет
                  </button>
                </div>
              </li>
            </ul>

            <ul className="form-full">
              <li className="form-block-popup width-4-blocks">
                <h4 className="heading-chapter">Инвойс</h4>
                <div className="flex-row-10">
                  <fieldset>
                    <legend>Номер и дата</legend>
                    <p className="text-form">
                      {replenishment.invoiceNumber} от {getFormattedDate(replenishment.invoiceDate || "")}
                    </p>
                  </fieldset>
                </div>
                <div className="flex-row-10">
                  <fieldset>
                    <legend>Сумма</legend>
                    <p className="text-form">
                      {spacedNum(replenishment.invoiceAmount ? Number(replenishment.invoiceAmount) / 100 : "")}{" "}
                      {replenishment.invoiceCurrency}
                    </p>
                  </fieldset>
                </div>
                <fieldset className="fieldset-fit">
                  <legend></legend>
                  <button
                    className="btn download-btn"
                    onClick={() => download(replenishment.id?.toString(), "CLIENT_INVOICE")}
                  >
                    <img src={IMG.download} alt="" />
                    Скачать
                  </button>
                </fieldset>
              </li>
              <li className="form-block-popup width-4-blocks">
                <h4 className="heading-chapter">Контракт с заводом</h4>

                <fieldset>
                  <legend>Дата</legend>
                  <p className="text-form">{getFormattedDate(replenishment.contractDate || "")}</p>
                </fieldset>
                <fieldset>
                  <legend>Номер</legend>
                  <p className="text-form">№{replenishment.contractNumber}</p>
                </fieldset>
                <fieldset className="fieldset-fit">
                  <legend></legend>
                  <button
                    className="btn download-btn"
                    onClick={() => download(replenishment.id?.toString(), "CLIENT_CONTRACT")}
                  >
                    <img src={IMG.download} alt="" />
                    Скачать
                  </button>
                </fieldset>
              </li>
              <li className="form-block-popup width-4-blocks">
                <h4 className="heading-chapter">Доп. соглашение</h4>
                <fieldset>
                  <legend>Дата</legend>
                  <p className="text-form">{getFormattedDate(replenishment.additionalAgreementDate || "")}</p>
                </fieldset>
                <fieldset>
                  <legend>Номер</legend>
                  <p className="text-form">№{replenishment.additionalAgreementNumber}</p>
                </fieldset>
                <div className="flex-row-10">
                  <button
                    className="btn download-btn"
                    onClick={() => download(replenishment.id?.toString(), "CLIENT_AGREEMENT")}
                  >
                    <img src={IMG.download} alt="" />
                    Скачать
                  </button>
                </div>
              </li>
              <li className="form-block-popup width-4-blocks">
                <h4 className="heading-chapter">Валютный плательщик</h4>
                <p className="valute-deal-user">{company?.name}</p>
              </li>
            </ul>
          </div>
        </div>
      </>
    )
  } else {
    return <></>
  }
}
